import type { ReleaseBuildInfo } from "@structura/core/release-metadata";
import { RELEASE_BUILD_INFO } from "@/generated/release-metadata";
import { STRUCTURA_RELEASE_REGISTRY } from "@/lib/structura-release-registry";

/** Build-time snapshot (regenerado en cada `npm run build`). */
export function getBuildReleaseInfo(): ReleaseBuildInfo {
  return RELEASE_BUILD_INFO;
}

export function getReleaseRegistry() {
  return STRUCTURA_RELEASE_REGISTRY;
}

/** Server: merge build file + Netlify/runtime env. */
export function resolveServerReleaseInfo(): ReleaseBuildInfo {
  const base = RELEASE_BUILD_INFO;
  const branch =
    process.env.BRANCH ??
    process.env.HEAD ??
    base.branch;
  const commit =
    process.env.COMMIT_REF ??
    process.env.NETLIFY_COMMIT_REF ??
    base.commit;
  const channel =
    (process.env.STRUCTURA_RELEASE_CHANNEL as ReleaseBuildInfo["channel"] | undefined) ??
    base.channel;
  const version =
    process.env.STRUCTURA_RELEASE_VERSION ??
    process.env.STRUCTURA_RELEASE_LABEL ??
    base.version;
  return {
    ...base,
    branch: branch ?? null,
    commit: commit ?? null,
    channel,
    version,
    releaseLabel: process.env.STRUCTURA_RELEASE_LABEL ?? base.releaseLabel,
    environment: process.env.NODE_ENV ?? base.environment ?? "development",
    builtAt: base.builtAt,
  };
}
